export function fmtTime(sec) {
  if (!sec || isNaN(sec)) return "0:00";
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function daysLabel(n) {
  if (n == null) return "";
  if (n <= 0) return "Expired";
  return `${n} day${n === 1 ? "" : "s"} left`;
}
